enum EApolloClients {
    PROMETHEUS = 'prometheus',
    APOLLO = 'default',
    APOLLO_SUBSCRIPTION = 'subscription',
}

export default EApolloClients
